import React from "react";
import { connect } from "react-redux";
import { Card, CardBody, Col, DropdownItem, Row } from "reactstrap";
import {
  ActionsRow,
  FixedDropDownButton,
  HorizontalLoader,
  Icon,
  InfiniteScroll,
  Loader,
  modal,
  utils,
} from "@mc/mc-legacy";
import QSignAdminApi from "../../../api/gen/qsign/QSignAdminApi";
import * as configurationActions from "../../../actions/configurationActions";
import { DetailValue } from "@mc/mc-legacy";
import "./SignConfigurationsList.scss";
import SignConfigurationForm from "../../forms/SignConfigurationForm";
import * as appUtils from "../../../utils/appUtils";
import * as findCombinationsActions from "../../../actions/findCombinationsActions";
import * as SignTimestampLevelInfo from "../../../api/SignTimestampLevelInfo";
import * as SealTimestampLevelInfo from "../../../api/SealTimestampLevelInfo";
import * as SealingLevelInfo from "../../../api/SealingLevelInfo";
import * as SigningLevelInfo from "../../../api/SigningLevelInfo";
import {cleanSigners} from "../../../utils/appUtils";

/**
 * Šablony - výpis / editace.
 */

class SignConfigurationsList extends React.Component {
  componentDidMount() {
    this.fetchData(this.props, true);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps);
  }

  fetchData = (props, force = false) => {
    props.dispatch(configurationActions.fetchSignConfigurationsIfNeeded(force));
    props.dispatch(findCombinationsActions.fetchCombinationsIfNeeded());
  };
  handleEditConfig = (item, kombinace) => {
    const { dispatch } = this.props;
    const { signers, ...other } = item;

    dispatch(
      modal.ModalActions.show(
        SignConfigurationForm,
        {
          onSubmit: (data) => {
            const { signers, typesCombination, ...other } = data;
            const dataFinal = {
                ...other,
                typesCombinationId: typesCombination.id,
                signers: cleanSigners(signers),
            };
            return QSignAdminApi.updateConfiguration(dataFinal.id, dataFinal);
          },
          onSubmitSuccess: (result, dispatch) => {
            dispatch(modal.ModalActions.hide());
            dispatch(configurationActions.fetchSignConfigurationsIfNeeded(true));
          },
          initialValues: {
            ...other,
            typesCombination: kombinace,
            signers: signers.length === 0 ? [{}] : signers,
          },
        },
        "Úprava konfigurace",
        {}
      )
    );
  };
  handleDeleteConfig = (item) => {
    const { dispatch } = this.props;
    dispatch(
      modal.ModalActions.showConfirm(
        "Potvrzení smazání",
        "Opravdu chcete smazat konfiguraci " + item.name + "?",
        () =>
          QSignAdminApi.deleteConfiguration(item.id).then(() => {
            dispatch(configurationActions.fetchSignConfigurationsIfNeeded(true));
          }),
        null,
        "Potvrdit"
      )
    );
  };
  renderItem = (item, key) => {
    const pracovnici = item.signers.map((signer) => signer.pracovnik);
    let pracovniLabel = pracovnici.map((pracovnik) => appUtils.getPracovnikLabel(pracovnik));
    pracovniLabel = pracovniLabel.join(", ");
    const kombinace = this.props.CombinationList.rows.find((x) => x.id === item.typesCombinationId);
    if (!kombinace) return <Loader />;
    return (
      <Card key={key}>
        <CardBody>
          <ActionsRow actions={this.renderActions(item, kombinace)}>
            <Row>
              <Col>
                <h2>{item.name} ({item.code})</h2>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <DetailValue textOverflow label="Podepisující" valueTitle={pracovniLabel}>
                  {item.signers.find((signer) => signer.blocked === true) ? (
                    <span className="blocked">{pracovniLabel}</span>
                  ) : (
                    pracovniLabel
                  )}
                </DetailValue>
              </Col>
                <Col xs={6} md={2}>
                    <DetailValue textOverflow label="Úroveň podpisu">
                        {SigningLevelInfo.getCaption(kombinace.signatureLevel)}
                    </DetailValue>
                </Col>
              <Col xs={6} md={2}>
                <DetailValue textOverflow label="Časové razítko podpisu">
                  {SignTimestampLevelInfo.getCaption(kombinace.signatureTimestampLevel)}
                </DetailValue>
              </Col>
              <Col xs={6} md={2}>
                <DetailValue textOverflow label="Pečeť">
                  {SealingLevelInfo.getCaption(kombinace.sealLevel)}
                </DetailValue>
              </Col>
              <Col xs={6} md={2}>
                <DetailValue textOverflow label="Časové razítko pečetě">
                  {SealTimestampLevelInfo.getCaption(kombinace.sealTimeStampLevel)}
                </DetailValue>
              </Col>
            </Row>
          </ActionsRow>
        </CardBody>
      </Card>
    );
  };
  renderActions = (item, kombinace) => {
    return (
      <Col className="item-actions">
        <FixedDropDownButton color="action" noCaret title={<Icon icon="ellipsis-v" className="item-actions-icon" />}>
          <DropdownItem key="1" onClick={() => this.handleEditConfig(item, kombinace)}>
            Upravit
          </DropdownItem>
          <DropdownItem key="2" onClick={() => this.handleDeleteConfig(item)}>
            Smazat
          </DropdownItem>
        </FixedDropDownButton>
      </Col>
    );
  };

  render() {
    const { signConfigurationList, CombinationList } = this.props;

    if (!signConfigurationList || !CombinationList) {
      return <Loader />;
    }
    return (
      <InfiniteScroll className="config-list" bordered>
        {signConfigurationList.isFetching && <HorizontalLoader key={'loader'} hover />}
        {signConfigurationList.rows.map((item, key) => {
          return this.renderItem(item, key);
        })}
      </InfiniteScroll>
    );
  }
}

function mapStateToProps(state) {
  return {
    signConfigurationList: utils.storeFromArea(state, configurationActions.SIGN_CONFIGURATION_LIST),
    CombinationList: utils.storeFromArea(state, findCombinationsActions.KOMBINACE_LIST),
  };
}

export default connect(mapStateToProps)(SignConfigurationsList);
